import { styled } from '@mui/material/styles';
import { Box, Typography, IconButton } from '@mui/material';

// Flex-grow container
export const GrowContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
}));

// Menu button with right margin
export const StyledMenuButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

// Title that hides on small screens
export const StyledTitle = styled(Typography)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("sm")]: {
    display: "block",
  },
}));

// Desktop-only section that shows on medium and up screens
export const DesktopSection = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

// Mobile-only section that hides on medium and up screens
export const MobileSection = styled(Box)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
})); 